/** @module DataLayerProductSelectItem */

import {
  DataLayerEventSelectItem,
  DataLayerViewItem,
} from "@/../types/data-layer";

import { DATA_LAYER_PRODUCT_SELECT_ITEM } from "@/constants";

/**
 * @Class
 * Representation of a product item listing from a user view for use in Google Tag Manager.
 * This data layer event is part of GA4 eCommerce tracking framework.
 *
 * https://aircanadavacations.atlassian.net/wiki/spaces/AW/pages/1957036058/Product+List+Views+Data+Layer+Event+view+item+list
 */
export class DataLayerProductSelectItem {
  /**
   *
   * @param {Array<DataLayerViewItem>} items
   */
  static create(items: DataLayerViewItem[]): DataLayerEventSelectItem {
    return {
      event: DATA_LAYER_PRODUCT_SELECT_ITEM,
      ecommerce: {
        items: items,
      },
    };
  }
}
